// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-complete-item[data-v-4a8b2970]{transition:all .4s ease}.list-complete-enter[data-v-4a8b2970],.list-complete-leave-to[data-v-4a8b2970]{opacity:0;transform:translateX(50vw)}.list-complete-leave-active[data-v-4a8b2970]{position:absolute}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
